module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h1"
  }, [_c('span', [_vm._v("Also by Michael Z. Lewin")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('b', [_vm._v("The Albert Samson Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Ask the Right Question")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("The Way We Die Now")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("The Enemies Within")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("The Silent Salesman")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Missing Woman")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Out of Season")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Called By a Panther")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Eye Opener")]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_vm._v("The Lt. Leroy Powder Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Night Cover")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Hard Line")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Late Payments")]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_vm._v("Indianapolis Novels")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Outside In")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("And Baby Will Fall")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Underdog")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Oh Joe")]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_vm._v("The Lunghi Family Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Family Business")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Family Planning")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Family Way")]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_vm._v("Other Novels")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Cutting Loose")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Confessions of a Discontented Deity")]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_vm._v("Story Collections")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Telling Tails")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Rover’s Tales")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("The Reluctant Detective and other stories")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Family Trio")]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_vm._v("Nonfiction")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("How to Beat College Tests: A Guide to Ease the Burden of Useless Courses")]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_vm._v("Novelization")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("The Next Man")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d48aee6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/titles.vue
// module id = 66
// module chunks = 0